import React, { useRef, useMemo } from 'react'
import PropTypes from 'prop-types'
import { TransitionGroup } from 'react-transition-group'
import { StyledCSSTransition } from './styled'
import { DEFAULT_TRANSITION_TIME } from 'constants/appConstants'

const TransitionContent = ({ currentState, children }) => {
  const refs = useRef([])
  children.forEach(() => refs.current.push(null))
  const childRefs = useMemo(
    () =>
      Array(children.length)
        .fill(0)
        .map(() => React.createRef()),
    [children.length]
  )

  return (
    <TransitionGroup>
      <StyledCSSTransition
        key={currentState}
        nodeRef={childRefs[currentState]}
        timeout={DEFAULT_TRANSITION_TIME}
        classNames='screen-transition'
      >
        <div ref={childRefs[currentState]}>{children[currentState]}</div>
      </StyledCSSTransition>
    </TransitionGroup>
  )
}

TransitionContent.propTypes = {
  children: PropTypes.array,
  currentState: PropTypes.number,
}

export default TransitionContent
